import { render, staticRenderFns } from "./Tipowalletsmaster.vue?vue&type=template&id=7d05f45c&"
import script from "./Tipowalletsmaster.vue?vue&type=script&lang=js&"
export * from "./Tipowalletsmaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports